import axios from "../../../axios";

export function fetchProductList() {
  const response = axios.get(`/products/categories/`);
  return response;
}
